/* istanbul ignore file */
import * as codec from 'purify-ts/Codec';
import { boolean as codecBoolean, number as codecNumber } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
import { TimeframeLike } from './TimeframeLike';
import { User } from './User';
import { WorkOrigin } from './WorkOrigin';
const WorkParser = /* #__PURE__ */ parsers.lazy(() => 
/* #__PURE__ */ parsers.object([
    ['id', codecNumber],
    ['user', User],
    ['origin', WorkOrigin],
    ['createdAt', parsers.moment, 'created_at'],
    ['grade', /* #__PURE__ */ parsers.maybeNull(codecNumber)],
    ['assignee', /* #__PURE__ */ parsers.maybeNull(User)],
    ['gradeOverridden', codecBoolean, 'grade_overridden'],
    ['extraInfo', codec.unknown, 'extra_info'],
    ['timeframe', TimeframeLike],
]));
export class Work extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return WorkParser.decode(input).map(res => new Work(res));
    }
    static unsafeDecode(input) {
        return Work.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return WorkParser.encode(data);
    }
    static schema() {
        return WorkParser.schema();
    }
}
